<template>
  <validation-observer v-if="editedValue" ref="observer" v-slot="{ changed, passes }">
    <b-modal
      id="community-user-role-edit-modal"
      ref="modal"
      :title="editedValue.id ? $t('user_roles.actions.edit') : $t('user_roles.actions.add')"
    >
      <b-form>
        <forms-validated-input
          type="relation"
          :label="$t('user_roles.fields.user')"
          name="user_id"
          :disabled="!canEditUser || disabled || loading"
          :rules="{
            required: true,
          }"
          :query="userQuery"
          :min-search-length="0"
          :value="editedValue.user ? editedValue.user.id : null"
          :object-value="editedValue.user"
          mode="eager"
          @relation="setUser"
        />

        <forms-validated-input
          type="select"
          :value="editedValue.role"
          :disabled="!canEditRole || disabled || loading"
          :options="roleOptions"
          name="role"
          :label="$t('user_roles.fields.role.title')"
          @input="setRole"
        />
      </b-form>

      <template #modal-footer>
        <div class="action-buttons">
          <icon-button
            role="save"
            :loading="loading"
            :disabled="disabled || loading || !changed"
            :onclick="async () => passes(save)"
            data-dusk="save-user-role-button"
          >
            {{ $t("forms.save") | capitalize }}
          </icon-button>
          <icon-button role="cancel" :disabled="disabled || loading" @click.prevent="cancel">
            {{ $t("forms.cancel") | capitalize }}
          </icon-button>
          <layout-loading v-if="loading" with-button />
        </div>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import FormsValidatedInput from "@/components/Forms/ValidatedInput.vue";
import IconButton from "@/components/shared/IconButton.vue";
import { capitalize } from "@/helpers/filters";

export default {
  name: "CommunityUserRoleForm",
  components: { IconButton, FormsValidatedInput },
  props: {
    canEditRole: { type: Boolean, default: true },
    canEditUser: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    value: { type: Object, default: null },
  },
  data() {
    return {
      editedValue: {
        ...this.value,
      },
      loading: false,
    };
  },
  computed: {
    roleOptions() {
      let options = [
        {
          value: "admin",
          text: capitalize(this.$t(`communities.fields.user_roles.role.options.admin`)),
        },
      ];
      return options;
    },
    userQuery() {
      const query = {
        slug: "users",
        value: "id",
        text: "full_name",
        details: "email",
        params: {},
      };
      return query;
    },
  },
  methods: {
    capitalize,
    show() {
      this.$nextTick(() => {
        this.editedValue = {
          ...this.value,
        };
        this.$bvModal.show("community-user-role-edit-modal");
      });
    },
    save() {
      this.$emit("save", this.editedValue);
      this.$bvModal.hide("community-user-role-edit-modal");
    },
    cancel() {
      this.$emit("cancel");
      this.$bvModal.hide("community-user-role-edit-modal");
    },
    setRole(role) {
      this.editedValue.role = role;
    },
    setUser(user) {
      this.editedValue.user_id = user?.id;
      this.editedValue.user = user;
    },
  },
};
</script>

<style scoped>
.action-buttons {
  display: flex;
  gap: 0.5rem;
}
</style>
